<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
const { $trackEvent } = useNuxtApp();
</script>

<template>
  <Button
    type="tertiary"
    padding="md"
    class="std-border w-full sm:justify-center"
    rounding="lg"
    @click="$trackEvent('NavigationEvent', 'DOWNLOAD_APP_CLICK')"
  >
    <div v-if="!!$slots?.icon" class="w-4 mr-1.5 sm:mr-2">
      <slot name="icon" />
    </div>
    <div
      v-if="!!$slots?.appType"
      class="text-xxs sm:text-xs text-left text-nowrap"
    >
      <span>{{ $t('download-for') }}&nbsp;</span>
      <br />
      <strong><slot name="appType" /></strong>
    </div>
    <slot />
  </Button>
</template>

<style scoped lang="scss"></style>
